module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("Reset Password")]), _vm._v(" "), (!_vm.token) ? _c('div', [_c('p', [_vm._v("You must provide a valid token to reset your password")])]) : _vm._e(), _vm._v(" "), (_vm.message) ? _c('div', [_c('p', [_vm._v(_vm._s(_vm.message))])]) : _vm._e(), _vm._v(" "), (_vm.token && _vm.canSubmit) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "six columns"
  }, [_c('label', {
    attrs: {
      "for": "reset-password"
    }
  }, [_vm._v("New Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "u-full-width",
    attrs: {
      "id": "reset-password",
      "type": "password",
      "placeholder": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && $event.keyCode !== 13) { return null; }
        _vm.submit($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "twelve columns"
  }, [_c('input', {
    staticClass: "button",
    attrs: {
      "value": "Set Password"
    },
    on: {
      "click": _vm.submit
    }
  })])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7cd6f71a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ResetPassword.vue
// module id = 279
// module chunks = 1